module.exports = __webpack_public_path__ + "static/media/tabletennis.d10aa6b3.svg";